<div class="cross-container">

    <div class="img-top" *ngIf="true">
        <img src="assets/img/golf.jpg" />
    </div>

    <div class="cross-row">
        <div class="cross-col-12" style="display: flex; justify-content: center;">
            <h1>{{ 'opengolf.search-package' | translate }}</h1>
        </div>

        <div class="cross-col-12" style="display: flex; justify-content: center; align-items: center;">
            <mat-form-field style="margin: 0 15px 0 0; min-width: 200px;">
                <!-- <mat-label>{{ 'Regione' | translate }}</mat-label> -->
                <mat-select #selectOraBi [(ngModel)]="currRegione" color="primary" (selectionChange)="selezionaRegione()">
                    <mat-option value="">{{ 'general.select' | translate }}...</mat-option>
                    <mat-option *ngFor="let regione of regioni; let i = index" [value]="regione">
                        {{ regione }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </div>
    </div>

    <!-- se ha abilitato la visualizzazione dei pacchetti -->
    <ng-container>
        <!-- *ngIf="app.appstore.C2" -->
        <div class="row biglietto" *ngIf="!pacchetti || pacchetti.length === 0">
            <div class="col-12" style="min-height: 150px; display: flex; justify-content: center; align-items: center;">
                {{ 'Nessun pacchetto disponibile' | translate }}
            </div>
        </div>

        <div class="row biglietto fadeInUp animated" *ngFor="let pac of pacchetti; let i = index">
            <!--  [ngClass]="getClass(i+1)" -->
            <div *ngIf="titolo(pac) && pac.C[0]" class="col-md-4 img-pacchetto" [style.background-image]="sanitizeImage(pac.Thumb)"></div>
            <div *ngIf="titolo(pac) && pac.C[0]" class="col-md-8 p-20">
                <h2 [innerHTML]="titolo(pac) | safeHtml"></h2>
                <p style="color: #555;" [innerHTML]="descrizione(pac) | safeHtml"></p>
                <p style="color: #555;margin-top: 15px">Prezzo a partire da <strong>{{ pac.N[0] | currency:'EUR' }}</strong>
                </p>
                <p style="color: #555;">
                    <ng-container *ngIf="pac.D[0] && pac.D[1]">
                        Offerta valida dal <strong>{{ pac.D[0].toString() | date: 'dd/MM/yyyy'}}</strong> al
                        <strong>{{ pac.D[1].toString() | date: 'dd/MM/yyyy' }}</strong>
                    </ng-container>
                    <ng-container *ngIf="pac.D[0] && !pac.D[1]">
                        Offerta valida dal <strong>{{ pac.D[0].toString() | date: 'dd/MM/yyyy'}}</strong>
                    </ng-container>
                    <ng-container *ngIf="!pac.D[0] && pac.D[1]">
                        Offerta valida fino al <strong>{{ pac.D[1].toString() | date: 'dd/MM/yyyy' }}</strong>
                    </ng-container>
                </p>
                <button mat-flat-button color="primary" (click)="getMoreInfo(pac, i)" class="mt-20">
                    <span *ngIf="!pac.isSelected">{{ 'Maggiori informazioni' | translate }}</span>
                    <span *ngIf="pac.isSelected">{{ 'Meno informazioni' | translate }}</span>
                </button>
            </div>

            <div [ngStyle]="getStyle(pac.isSelected)" style="overflow: hidden; transition: all ease .5s" *ngIf="hotels && hotels[i] && hotels[i].hotel && pac.C[0]">
                <div class="mt-20">
                    <h1 style="text-align: center;">{{ hotels[i].hotel.title }}</h1>
                </div>
                <ng-container *ngIf="hotels[i].gallery">
                    <ng-container *ngIf="hotels[i].gallery.length >= 3">
                        <div class="row">
                            <div class="col-12 col-sm-4" style="padding: 0;">
                                <div class="d-none d-sm-block" style="padding-right: 15px">
                                    <div class="img-gallery" style="width: 100%; height: 200px; margin-bottom: 15px;" [style.background-image]="sanitizeImage(hotels[i].gallery[1].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                    <div class="img-gallery" style="width: 100%; height: 200px;" [style.background-image]="sanitizeImage(hotels[i].gallery[2].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                </div>
                                <div class="d-flex d-sm-none" style="padding: 0">
                                    <div class="img-gallery" style="width: 50%; height: 100px; margin-bottom: 15px; margin-right: 5px;" [style.background-image]="sanitizeImage(hotels[i].gallery[1].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                    <div class="img-gallery" style="width: 50%; height: 100px; margin-left: 5px;" [style.background-image]="sanitizeImage(hotels[i].gallery[2].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                                </div>
                            </div>
                            <div class="col-12 col-sm-8" style="padding: 0">
                                <div class="d-none d-sm-block img-gallery" style="width: 100%; height: 415px; position: relative;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])">
                                    <div *ngIf="hotels[i].gallery.length > 3" class="other-photos">Altre {{ hotels[i].gallery.length - 3}} foto</div>
                                </div>
                                <div class="d-block d-sm-none img-gallery" style="width: 100%; height: 200px; position: relative;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])">
                                    <div *ngIf="hotels[i].gallery.length > 3" class="other-photos">Altre {{ hotels[i].gallery.length - 3}} foto</div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="hotels[i].gallery.length == 2">
                        <div class="row px-20">
                            <div class="col-7" style="padding-right: 15px">
                                <div class="img-gallery" style="width: 100%; height: 200px; margin-bottom: 15px;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                            </div>
                            <div class="col-5" style="padding-left: 0">
                                <div class="img-gallery" style="width: 100%; height: 200px; position: relative;" [style.background-image]="sanitizeImage(hotels[i].gallery[1].URL)" (click)="openGalleryDialog(hotels[i])">
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="hotels[i].gallery.length == 1">
                        <div class="row px-20">
                            <div class="col-12" style="padding-right: 15px">
                                <div class="img-gallery" style="width: 100%; height: 200px; margin-bottom: 15px;" [style.background-image]="sanitizeImage(hotels[i].gallery[0].URL)" (click)="openGalleryDialog(hotels[i])"></div>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="hotels[i].hotel">
                    <div class="row px-20 my-20">
                        <div class="col-12 col-sm-6 mb-20" style="line-height: 2;">
                            <h5 class="mb-30">Contatti</h5>
                            <!-- <div>{{ hotels[i].hotel.company }}</div> -->
                            <div>
                                {{ hotels[i].hotel.address }}{{ ', ' + hotels[i].hotel.city }}{{ ' (' + hotels[i].hotel.province + ')' }}{{ ' - ' + hotels[i].hotel.zip }}
                            </div>
                            <div><a [href]="hotels[i].hotel.website">{{ hotels[i].hotel.website }}</a></div>
                            <div>Email: {{ hotels[i].hotel.email }}</div>
                            <div>Telefono: {{ hotels[i].hotel.phone }}</div>
                        </div>
                        <div class="col-12 col-sm-6">
                            <h5>Richiedi informazioni per:<br />{{ titolo(pac) }}</h5>
                            <mat-form-field class="full-width" style="max-width: 400px">
                                <mat-label>Nome (*)</mat-label>
                                <input matInput [(ngModel)]="prenotaNome" (change)="checkForm()">
                            </mat-form-field>
                            <mat-form-field class="full-width" style="max-width: 400px">
                                <mat-label>Email (*)</mat-label>
                                <input matInput [(ngModel)]="prenotaEmail" (change)="checkForm()">
                            </mat-form-field>
                            <mat-form-field class="full-width" style="max-width: 400px">
                                <mat-label>Cellulare</mat-label>
                                <input matInput [(ngModel)]="prenotaMobile">
                            </mat-form-field>
                            <mat-form-field class="full-width textarea" style="max-width: 400px">
                                <mat-label>Messaggio (*)</mat-label>
                                <textarea matInput [(ngModel)]="prenotaTesto" (change)="checkForm()" style="min-height: 60px;"></textarea>
                            </mat-form-field>

                            <!-- TODO: alex -->
                            <!-- aggiungere checkbox privacy default: https://opengolf.it/it/privacy-policy -->
                            <!-- captcha -->
                            <!-- aggiungere campo "Pacchetto" inserendo il nome del pacchetto sopra -->

                            <re-captcha #recaptcha (resolved)="resolved($event)" siteKey="6Le7lvYhAAAAAMeOWm5GTZmchc_lsdum6kZvYnkv"></re-captcha>

                            
                            <div class="mt-20" style="display: flex; justify-content: center; align-items: start;">
                                <mat-checkbox [(ngModel)]="privacy" color="primary" style="font-size: .9rem" (change)="checkForm()">
                                </mat-checkbox>
                                <div>
                                    {{ 'login.privacy1' | translate }}
                                    <span class="link" (click)="openUrl('')">{{ 'login.privacy' | translate }}</span> {{ 'login.privacy2' | translate }}
                                </div>
                            </div>

                            <div class="mt-10" style="font-size: .9rem">
                                {{ 'login.required-fields' | translate }}
                            </div>
                            
                            <div class="mt-15" style="width: 100%; display: flex; flex-direction: column;">
                                <div class="mb-5" *ngIf="errorMessage" style="color: red;">{{ errorMessage | translate }}</div>

                                <button style="width: 100px;" mat-button class="container-buy-button shop-button shop-button-label" (click)="inviaHotel(hotels[i].hotel.username, titolo(pac) )">
                                    {{ 'general.send' | translate }}
                                </button>
                            </div>

                            <!-- <div class="mb-5" *ngIf="errorMessage" style="color: red;">{{ errorMessage }}</div>

                            <button mat-flat-button color="primary" (click)="inviaHotel(hotels[i].hotel.username, titolo(pac) )">
                                <span class="shop-button-label">{{ 'general.send' | translate }}</span>
                            </button> -->

                            <!-- <button mat-button class="container-buy-button shop-button shop-button-label" (click)="inviaHotel(hotels[i].hotel.username, titolo(pac) )" style="float: none">
                <span class="shop-button-label">{{ 'general.send' | translate }}</span>
            </button> -->
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

    </ng-container>

    <app-credits [configApp]="app" *ngIf="app"></app-credits>

    <div style="clear: both;margin-bottom:50px"></div>
</div>